/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show or hide reference sketches</h4>

<p>Show or hide the imported reference sketches.</p>`;

export default function ShowSketchesTooltip() {
    return h('div', { innerHTML: body });
}
